import { Grid, styled } from "@mui/material";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import { ComparisonCard, ComparisonData } from "./Common/ComparisonCard";
import { CommonChartProps } from "../chart.types";
import { SummaryLayout } from "./SummaryLayout";

type ComparisonChartProps = CommonChartProps;
export const ComparisonChart = (props: ComparisonChartProps) => {
    const {
        drilldownState,
        scoreList: { lastSelected },
    } = useScoreDetailContext();

    const { data, total } = props;

    if (total === null) {
        // Just want to make sure I have total
        return;
    }
    const comparisonCardTotal: ComparisonData = {
        key: total.title,
        title: total.title,

        min: total.score.min,
        max: total.score.max,
        average: total.score.avg,
        count: total.score.count,
        value: total.score.value,
    };

    const comparisonCardData: ComparisonData[] = data.map((item) => {
        return {
            key: item.title,
            title: item.title,

            min: item.score.min,
            max: item.score.max,
            average: item.score.avg,
            count: item.score.count,
            value: item.score.value,
            action: item.action,

            noData: false,
            noDimensions: false,
        };
    });

    if (drilldownState.state.length === 0) {
        const items = [comparisonCardTotal, ...comparisonCardData];
        return <SummaryLayout items={items} />;
    }

    return (
        <ComparisonScoreGrid container spacing={2}>
            {comparisonCardData.map((score) => {
                return (
                    <Grid item xs={4} key={score.title}>
                        <ComparisonCard
                            score={score}
                            unit={lastSelected.unit}
                            scorePrecision={lastSelected.precision}
                        />
                    </Grid>
                );
            })}
        </ComparisonScoreGrid>
    );
};

const ComparisonScoreGrid = styled(Grid)<{ direction?: "row" | "column" }>(({ theme, direction = "row" }) => ({
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: direction,
    padding: theme.spacing(2),
    height: "100%",
    width: "100%",
}));
